/** Must match API `GALLERY_TOKEN_EXPIRATION_MINUTES` in inspection.service.ts (90 days). */
export const GALLERY_TOKEN_EXPIRATION_MS = 90 * 24 * 60 * 60 * 1000;

export function isActiveGalleryToken(token?: string | null, createdAt?: string | Date | null): boolean {
  if (!token) return false;
  if (!createdAt) return true;
  const created = new Date(createdAt).getTime();
  if (Number.isNaN(created)) return true;
  return created >= Date.now() - GALLERY_TOKEN_EXPIRATION_MS;
}

export function galleryTokenCreatedAtFromResponse(
  response: {
    createdAt?: string | Date;
    galleryMarkupTokenCreatedAt?: string | Date;
    galleryTokenCreatedAt?: string | Date;
  } | null,
  existing?: string | Date | null,
): string | Date {
  return (
    response?.createdAt ??
    response?.galleryMarkupTokenCreatedAt ??
    response?.galleryTokenCreatedAt ??
    existing ??
    new Date()
  );
}

export function msUntilGalleryTokenExpiry(createdAt?: string | Date | null): number | null {
  if (!createdAt) return null;
  const created = new Date(createdAt).getTime();
  if (Number.isNaN(created)) return null;
  return created + GALLERY_TOKEN_EXPIRATION_MS - Date.now();
}
